<div class="dropdown dropdown-right">
  <a class="dropdown-toggle selected-lang" tabindex="0">
    <material-icon>language</material-icon>
    <span class="text-bold bold">{{ selectedLang | uppercase }}</span>
  </a>
  <ul class="menu text-left">
    <li *ngFor="let language of supportedLangs; trackBy: trackByFn" class="menu-item">
      <a class="menu-link" translate="no" [class.inactive]="!language.selected" (click)="selectLanguage(language.value)">
        <material-icon *ngIf="language.selected" class="lang-icon">fiber_manual_record</material-icon>
        {{ language.label | translate }}
      </a>
    </li>
  </ul>
</div>
